import { render, staticRenderFns } from "./deactivatedListing.vue?vue&type=template&id=0180aca7&scoped=true"
import script from "./deactivatedListing.vue?vue&type=script&lang=js"
export * from "./deactivatedListing.vue?vue&type=script&lang=js"
import style0 from "./deactivatedListing.vue?vue&type=style&index=0&id=0180aca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180aca7",
  null
  
)

export default component.exports